import styled from '@emotion/styled';
import { Stack, Flex } from '@pairy/pds-react';

import { Z_INDEX } from '@/constants/zIndex';

export const GrayBox = styled(Stack)`
  border-radius: 8px;
`;

export const LoadingWrapper = styled(Flex)`
  position: absolute;

  z-index: ${Z_INDEX.loadingWrapper};
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  background: rgb(255 255 255 / 75%);
`;
